
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface UserAvatarProps {
  fullName?: string;
  email?: string;
}

export const UserAvatar = ({ fullName, email }: UserAvatarProps) => {
  const getInitials = () => {
    if (fullName) {
      return fullName
        .split(' ')
        .slice(0, 2)
        .map(name => name.charAt(0).toUpperCase())
        .join('');
    }
    
    if (email) {
      return email.charAt(0).toUpperCase();
    }
    
    return "U";
  };
  
  return (
    <Avatar className="h-8 w-8">
      <AvatarImage src="" alt={fullName || email || "User"} />
      <AvatarFallback>{getInitials()}</AvatarFallback>
    </Avatar>
  );
};
